import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-eenzaamheid',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconEenzaamheid {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M25 7.75v.5c0 .41-.39.75-.88.75h-1.35c.14-.55.23-1.11.23-1.64V7h1.12c.48 0 .88.34.88.75M28 19H16.75l-3.88 3.82c-.1.09-.22.14-.35.14-.06 0-.13-.01-.19-.04a.499.499 0 0 1-.31-.46l-.03-3.47h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2ZM27 7.75C27 6.23 25.71 5 24.12 5H23c0-.55-.45-1-1-1H12c-.55 0-1 .45-1 1v2.36c0 2.04 1.12 4.36 2.78 5.64H11c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.78c.68-.53 1.26-1.23 1.72-2.01.02 0 .04.01.06.01h2.12C25.7 11 27 9.77 27 8.25zm6.04 23.29h-7.08c-1.65 0-2.96 1.25-2.96 2.8V35c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-1.44c-.15-1.41-1.41-2.52-2.96-2.52M26 25.5c0 1.94 1.57 3.51 3.51 3.51s3.51-1.57 3.51-3.51-1.57-3.51-3.51-3.51S26 23.56 26 25.5m-15.96 5.54H2.96c-1.65 0-2.96 1.25-2.96 2.8V35c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-1.44c-.15-1.41-1.41-2.52-2.96-2.52M6.5 29.01c1.94 0 3.51-1.57 3.51-3.51s-1.57-3.51-3.51-3.51-3.51 1.57-3.51 3.51 1.57 3.51 3.51 3.51"/>
</svg>

    );
  }
}
